import Facade from '@/Facade'

/** Social-casino English: prizes are "prize pools" rather than "jackpots", with its own artwork. */
export const SOCIAL_CASINO_LOCALE = 'en_sc'

/**
 * Read the locale from the URL rather than from the translations module: component configs are
 * built at import time, well before urlParams and the dictionaries are guaranteed to exist.
 *
 * The framework normalizes locales with `split('-')`, so `en-sc` would collapse to `en` and load the
 * wrong dictionary. Only the underscore form is a social-casino build.
 */
export const getGameLocale = (): string => {
    try {
        return (Facade.urlParams?.language || new URLSearchParams(window.location.search).get('language') || '')
            .trim()
            .toLowerCase()
    } catch {
        return ''
    }
}

export const isSocialCasinoLocale = (): boolean => getGameLocale() === SOCIAL_CASINO_LOCALE

/**
 * True when the wording baked into the artwork already reads correctly.
 *
 * Words drawn into atlases and spine skins exist twice — English, and the social-casino rewording —
 * so every other locale has to have that copy typed out at runtime instead.
 */
export const isEnglishArtLocale = (): boolean => {
    const locale = getGameLocale()

    if (!locale || locale === SOCIAL_CASINO_LOCALE) {
        return true
    }

    // The framework resolves `en-gb` and friends down to `en`, and the artwork follows.
    return locale.split('-')[0] === 'en'
}
